import { RoundingType } from '@shared/transactions-types';

import type { TransactionPredicate } from './types';

export const hasRoundingDonation: TransactionPredicate = ({ roundingAmount, roundingType }) =>
    Boolean(roundingAmount && roundingType === RoundingType.DONATION);
